var render, staticRenderFns
import script from "./BreadcrumbsJsonLd.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbsJsonLd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055d3fa3')) {
      api.createRecord('055d3fa3', component.options)
    } else {
      api.reload('055d3fa3', component.options)
    }
    
  }
}
component.options.__file = "src/core/CoreBread/BreadcrumbsJsonLd.vue"
export default component.exports